<template>
  <div class="portbook-main" ref="portbook-main">

    <div class="portbook-timeout">
      {{data ? ((data['timeout'] >= 0) ? timeoutFormat(data['timeout']) : '') : ''}}
    </div>

    <div class="portbook-timeout-cover" v-if="data && (data['timeout'] <= 0)">
      <div class="title">Session Timed Out</div>
    </div>

    <div class="portbook-jobs">
      <div class="job-item" v-for="(j, i) in data['jobs']" :key="'job' + i">
        <div class="job-header">{{ j ? (j['ConsignmentNo'] ? j['ConsignmentNo'].trim() : '') : '' }}</div>

        <div class="job-row">
          <div class="title">
            <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('1') : -1) >= 0) ? 'green' : 'red') }">Driver</div>
            <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('1') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['DriverName'] ? j['DriverName'].trim() : '-') : '-' }}</div>
            <div class="value-row">{{ j ? (j['drivernric'] ? j['drivernric'].trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="job-row">
          <div class="title">
            <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('2') : -1) >= 0) ? 'green' : 'red') }">Vehicle Head</div>
            <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('2') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['PMCode'] ? j['PMCode'].trim() : '-') : '-' }}</div>
            <div class="value-row">{{ j ? (j['PMNo'] ? j['PMNo'].trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="job-row">
          <div class="title">
            <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('3') : -1) >= 0) ? 'green' : 'red') }">Trailer</div>
            <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('3') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['TRCode'] ? j['TRCode'].trim() : '-') : '-' }}</div>
            <div class="value-row">{{ j ? (j['TRNo'] ? j['TRNo'].trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="job-row">
          <div class="title">
            <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('4') : -1) >= 0) ? 'green' : 'red') }">Container(s)</div>
            <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('4') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['ContainerNo'] ? j['ContainerNo'].trim() : '-') : '-' }}</div>
            <div class="value-row">{{ j ? (j['B2BContainerNo'] ? j['B2BContainerNo'].trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="job-row">
          <div class="title">
            <div class="title-text">Port(s) DateTime</div>
            <!-- <div class="title-text" :style="{ 'color': (((j['steps'] ? j['steps'].search('5') : -1) >= 0) ? 'green' : 'red') }">Port(s) DateTime</div> -->
            <!-- <img class="title-icon" :src="'https://dsmlib.logistics.systems/Icons/' + (((j['steps'] ? j['steps'].search('5') : -1) >= 0) ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png')" alt=""/> -->
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['port_opening'] ? 'Open  : ' + j['port_opening'].trim() : '-') : '-' }}</div>
            <div class="value-row">{{ j ? (j['port_closing'] ? 'Close : ' + j['port_closing'].trim() : '-') : '-' }}</div>
          </div>
        </div>

        <div class="job-row">
          <div class="title">
            <div class="title-text">SOLAS</div>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['solas'] ? j['solas'].trim() : '-') : '-' }}</div>
          </div>
        </div>
        
        <div class="job-row" v-if="j['B2BContainerNo']">
          <div class="title">
            <div class="title-text">Port(s) DateTime (B2B)</div>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['b2bport_opening'] ? 'Open: ' + j['b2bport_opening'].trim() : '-') : '-' }}</div>
            <div class="value-row">{{ j ? (j['b2bport_closing'] ? 'Close: ' + j['b2bport_closing'].trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="job-row" v-if="j['B2BContainerNo']">
          <div class="title">
            <div class="title-text">SOLAS (B2B)</div>
          </div>
          <div class="value">
            <div class="value-row">{{ j ? (j['b2bsolas'] ? j['b2bsolas'].trim() : '-') : '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="portbook-functions">
      <div class="timeslot-details">
        <div class="timeslot-row">
          <div class="title">
            <div class="title-text">Total</div>
          </div>
          <div class="value">
            <div class="value-row">{{ timeslotsSel ? (timeslotsSel['total'] ? timeslotsSel['total'].toString().trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="timeslot-row">
          <div class="title">
            <div class="title-text">Available</div>
          </div>
          <div class="value">
            <div class="value-row">{{ timeslotsSel ? (timeslotsSel['available'] ? timeslotsSel['available'].toString().trim() : '-') : '-' }}</div>
          </div>
        </div>
        <div class="timeslot-row">
          <div class="title">
            <div class="title-text">Used</div>
          </div>
          <div class="value">
            <div class="value-row">{{ timeslotsSel ? (timeslotsSel['used'] ? timeslotsSel['used'].toString().trim() : '-') : '-' }}</div>
          </div>
        </div>

        <div class="timeslot-row" style="width: 100%;">
          <div class="title">
            <div class="title-text">Timeslot Date/Time</div>
          </div>
          <div class="value">
            <div class="value-row">{{ timeslotsSel ? (timeslotsSel['start'] ? ('Start : ' + timeslotsSel['start'].toString().trim()) : '-') : '-' }}</div>
            <div class="value-row">{{ timeslotsSel ? (timeslotsSel['end'] ? ('End   : ' + timeslotsSel['end'].toString().trim()) : '-') : '-' }}</div>
          </div>
        </div>
      </div>

      <Input placeholder="Port/Depot" :isDisabled="true" :inputValue="((data['jobs'] && data['jobs']['length'] > 0) ? (data['jobs'][0]['usecontterminal'] ? data['jobs'][0]['usecontterminal'].toString().trim() : '') : '')"/>
      <Dropdown placeholder="Timeslot" :items="timeslots" :selectedObject.sync="timeslotsSel" itemKey="start" :isRequired="true"/>
      <Dropdown placeholder="Trailer" :items="trailers" :selectedObject.sync="trailersSel" itemKey="description" :allowFreeText="true" :search.sync="trailersSearch" :isRequired="true"/>
      <RemarksBox class="portbook-remarks" title="Remarks" :maxLength="300" :text.sync="remarks"/>
    </div>

    <Loader class="loaderMain" ref="loaderMain" :isVisible="(data['loadText'] != '')" :loadingText="data['loadText']"/>
  </div>
</template>

<script>
  /* eslint-disable */

  export default {
    components: {
    },
    props: {
      //-- Main Props
      data: { type: Object, default: function () { return {}; } },
      viewMode: { type: Boolean, default: false },
      errorFlag: { type: Boolean, default: false }, 
      
      //-- Load Props
      loadShow: { type: Boolean, default: false },
      loadText: { type: String, default: 'Loading' },
    },
    data() {
      return {
        timeslots: [],
        timeslotsSel: null,
        trailers: [],
        trailersSel: null,
        trailersSearch: "",
        remarks: '',
      }
    },
    computed: {
      getJobsLength() {
        return this.data['jobs']['length'];
      },
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData: async function() {
        this.checkForTimeslots();
        this.populateTrailersDropdown();

        //-- Set overflow visible for Entry Body
        this.$refs['portbook-main']['parentNode']['parentNode']['style'] = 'overflow: visible;';
      },
      checkForTimeslots: async function() {
        if (this.data && this.data['jobs']['length'] > 0) {
          if (this.data['jobs'][0]['timeslots'] && this.data['jobs'][0]['timeslots']['slots']) {
            this.timeslots = this.data['jobs'][0]['timeslots']['slots'];
          }
        }
      },
      populateTrailersDropdown: function() {
        if (!this.data || !this.data["trailers"] || this.data["trailers"].length == 0) {
          this.trailers = [];
          // this.trailersSel = null;
          return;
        }

        this.trailers = this.data["trailers"];

        if (!this.data["jobs"] || this.data["jobs"].length == 0) {
          // this.trailersSel = null;
          return;
        }

        // this is supposed to auto select a trailer based on the job details, but it's causing a bug right now
        // due to the nature of how EntryPopup was coded
        // don't think I can fix it, will implement this feature when I rewrite this into PopupEntry for VehicleSchedule page later
        // this.trailersSel = this.trailers.find((trailer) => { return trailer["VehicleCode"].trim() === this.data["jobs"][0]["TRNo"]; }) || null;
      },

      resetFields: async function() {
        this.timeslotsSel = null;
        this.remarks = '';
      },
      timeoutFormat(time) {
        var minutes = Math.floor(time / 60);
        var seconds = time % 60;

        return 'Timeout: ' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      },
      
      //---- Utility Methods
      formatDatetoString: function (date) {
        if (typeof date == 'string') {
          var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '').replace(/\-/g, '-');
          try {
            var dateFF = new Date(dateF);
            if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
          } catch (e) { /*console.log(e);*/ }
        } else {
          var dateFF = date;
        }
        
        var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
        var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
        var y = dateFF.getFullYear();
        var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
        var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

        return `${y}-${m}-${d} ${hh}:${mm}`;
      },
      formatStringtoDate: function (date) {
        var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
        var dateFF = dateF.split('/');
        return new Date(dateFF[0], (parseInt(dateFF[1]) - 1).toString(), dateFF[2], dateFF[3], dateFF[4]);
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
      data: { deep: true, handler(h) {
        this.checkForTimeslots();
        this.populateTrailersDropdown();
      }},
      getJobsLength: { deep: false, handler(h) { this.resetFields(); }},
      timeslotsSel: { deep: true, handler(h) {
        this.data['jobs'].forEach((d, i) => {
          this.$set(d, 'timeslotsSel', this.timeslotsSel);
          // console.log(d);
        });
      }},
      trailersSel: {
        handler: function(trailer) { // updates the prop, because there's no .sync between PortBookingv2 and EntryPopup
          this.$set(this.data, 'trailersSel', trailer);
        },
        deep: true,
      },
      trailersSearch: function(search) {
        this.$set(this.data, 'trailersSearch', search);
      },
      remarks: { deep: true, handler(h) {
        this.data['jobs'].forEach((d, i) => {
          this.$set(d, 'remarks', this.remarks);
        });
      }},
    },
  }
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .portbook-main {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    > .portbook-timeout {
      width: auto;
      height: 17.5px;
      font-size: 12px;
      font-weight: bold;
      position: absolute;
      top: -28px;
      right: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    > .portbook-timeout-cover {
      width: auto;
      height: auto;
      position: absolute;
      top: -5px;
      bottom: -5px;
      left: -5px;
      right: -5px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #0004;
      z-index: 10;

      > .title {
        width: auto;
        height: auto;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 8px #0004;
        user-select: none;
      }
    }

    > .portbook-jobs {
      width: 60%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > .job-item {
        width: 100%;
        height: 100%;
        max-width: calc(50% - 2.5px);
        padding: 5px 5px 0 5px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: #eaeaea;
        border: solid 1px #0004;
        border-radius: 5px;

        > .job-header {
          width: 100%;
          height: 24px;
          margin: 0 0 5px 0;
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ffffff;
          border: solid 1px #0004;
          border-radius: 5px;
        }

        > .job-row {
          width: 100%;
          height: auto; 
          padding: 2px 5px;
          margin: 0 0 5px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          background-color: #ffffff;
          border: solid 1px #0004;
          border-radius: 5px;

          > .title {
            width: 100%;
            height: 20px;
            margin: 0 0 2px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            > .title-text {
              width: auto;
              height: 100%;
              flex: 1;
              font-size: 13px;
              font-weight: bold;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            > .title-icon {
              width: 20px;
              height: 20px;
              user-select: none;
            }
          }

          > .value {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            > .value-row {
              width: 100%;
              height: 15px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              white-space: nowrap;
              overflow: hidden;
              white-space: pre;
            }
          }
        }
      }
    }

    > .portbook-functions {
      width: 40%;
      height: 100%;
      padding: 0 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      > .timeslot-details {
        width: 100%;
        height: auto; 
        padding: 5px 5px 0 5px;
        margin: 0 0 10px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        background-color: #eaeaea;
        border: solid 1px #0004;
        border-radius: 5px;

        > .timeslot-row {
          width: calc(33% - 3.33px);
          height: auto; 
          padding: 2px 5px;
          margin: 0 0 5px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          background-color: #ffffff;
          border: solid 1px #0004;
          border-radius: 5px;

          > .title {
            width: 100%;
            height: 20px;
            margin: 0 0 2px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            > .title-text {
              width: auto;
              height: 100%;
              flex: 1;
              font-size: 13px;
              font-weight: bold;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
          }

          > .value {
            width: 100%;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            > .value-row {
              width: 100%;
              height: 15px;
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              white-space: nowrap;
              overflow: hidden;
              white-space: pre;
            }
          }
        }
      }

      > .portbook-remarks {
        width: 100%;
        max-height: 200px;
      }
    }
  }



</style>